__turbopack_context__.v({
  "avatar": "page-module__rM2rjG__avatar",
  "btBadge": "page-module__rM2rjG__btBadge",
  "btBadgeNeutral": "page-module__rM2rjG__btBadgeNeutral",
  "btBadgeOk": "page-module__rM2rjG__btBadgeOk",
  "btBadgeWarn": "page-module__rM2rjG__btBadgeWarn",
  "btConnectBtn": "page-module__rM2rjG__btConnectBtn",
  "btConnectBtnActive": "page-module__rM2rjG__btConnectBtnActive",
  "btDeviceActiveBadge": "page-module__rM2rjG__btDeviceActiveBadge",
  "btDeviceAddress": "page-module__rM2rjG__btDeviceAddress",
  "btDeviceInfo": "page-module__rM2rjG__btDeviceInfo",
  "btDeviceItem": "page-module__rM2rjG__btDeviceItem",
  "btDeviceName": "page-module__rM2rjG__btDeviceName",
  "btDeviceNameRow": "page-module__rM2rjG__btDeviceNameRow",
  "btDevicesCard": "page-module__rM2rjG__btDevicesCard",
  "btDevicesEmpty": "page-module__rM2rjG__btDevicesEmpty",
  "btDevicesList": "page-module__rM2rjG__btDevicesList",
  "btDevicesTitle": "page-module__rM2rjG__btDevicesTitle",
  "btError": "page-module__rM2rjG__btError",
  "btHeader": "page-module__rM2rjG__btHeader",
  "btHeaderActions": "page-module__rM2rjG__btHeaderActions",
  "btHeaderTitle": "page-module__rM2rjG__btHeaderTitle",
  "btHint": "page-module__rM2rjG__btHint",
  "btInfo": "page-module__rM2rjG__btInfo",
  "btRefreshBtn": "page-module__rM2rjG__btRefreshBtn",
  "btSecondaryBtn": "page-module__rM2rjG__btSecondaryBtn",
  "btSection": "page-module__rM2rjG__btSection",
  "btStatusRow": "page-module__rM2rjG__btStatusRow",
  "container": "page-module__rM2rjG__container",
  "customTemplateField": "page-module__rM2rjG__customTemplateField",
  "customTemplateToggle": "page-module__rM2rjG__customTemplateToggle",
  "emptyCard": "page-module__rM2rjG__emptyCard",
  "emptyHistory": "page-module__rM2rjG__emptyHistory",
  "emptyIcon": "page-module__rM2rjG__emptyIcon",
  "historyItem": "page-module__rM2rjG__historyItem",
  "historyList": "page-module__rM2rjG__historyList",
  "historySection": "page-module__rM2rjG__historySection",
  "historyTitle": "page-module__rM2rjG__historyTitle",
  "logoutBtn": "page-module__rM2rjG__logoutBtn",
  "primaryBtn": "page-module__rM2rjG__primaryBtn",
  "printActions": "page-module__rM2rjG__printActions",
  "printBtn": "page-module__rM2rjG__printBtn",
  "printCard": "page-module__rM2rjG__printCard",
  "printChip": "page-module__rM2rjG__printChip",
  "printChipActive": "page-module__rM2rjG__printChipActive",
  "printHint": "page-module__rM2rjG__printHint",
  "printMeta": "page-module__rM2rjG__printMeta",
  "printMetaActions": "page-module__rM2rjG__printMetaActions",
  "printMetaRow": "page-module__rM2rjG__printMetaRow",
  "printPreview58": "page-module__rM2rjG__printPreview58",
  "printPreview80": "page-module__rM2rjG__printPreview80",
  "printPreviewBox": "page-module__rM2rjG__printPreviewBox",
  "printResetBtn": "page-module__rM2rjG__printResetBtn",
  "printTitle": "page-module__rM2rjG__printTitle",
  "profileCard": "page-module__rM2rjG__profileCard",
  "roleTag": "page-module__rM2rjG__roleTag",
  "templateField": "page-module__rM2rjG__templateField",
  "templateFieldWide": "page-module__rM2rjG__templateFieldWide",
  "templateFormGrid": "page-module__rM2rjG__templateFormGrid",
  "title": "page-module__rM2rjG__title",
});
